import { CalendarClock, ChevronRight, Mail, MessageSquarePlus, Star, UserRound } from "lucide-react";
import { useEffect, useState } from "react";
import { FOLLOW_UP_STATUS } from "../../lib/statuses";
import { formatDateTime, safeText } from "../../lib/formatters";
import { Button } from "../../components/ui/Button";
import { SelectInput, TextArea, TextInput } from "../../components/ui/Form";

export default function CustomerContext({ context, currentInquiryId, onOpenHistory, onSaveFollowUp, onAddNote, busy }) {
  const profile = context?.profile || {};
  const [followUp, setFollowUp] = useState({ follow_up_status: "new", next_follow_up_at: "" });
  const [note, setNote] = useState("");
  useEffect(() => {
    setFollowUp({
      follow_up_status: profile.follow_up_status || "new",
      next_follow_up_at: profile.next_follow_up_at ? String(profile.next_follow_up_at).slice(0, 16) : "",
    });
  }, [profile.follow_up_status, profile.next_follow_up_at]);
  return (
    <section className="customer-context">
      <header className="content-section-header">
        <div><h3>历史往来与跟进</h3><small>同一客户共 {profile.inquiry_count || context?.history?.length || 0} 封询盘</small></div>
      </header>
      {context?.profile ? (
        <div className="customer-rating-summary" aria-label="客户项目评级摘要">
          <span><Star size={15} /><small>当前项目优先级</small><strong>{Number(profile.customer_level || profile.latest_inquiry_rating || 0)} 星</strong></span>
          <span><small>历史最高项目</small><strong>{Number(profile.highest_inquiry_rating || 0)} 星</strong></span>
          <p>{profile.customer_level_reason || "当前优先级按最近一次项目计算，历史最高星级单独保留。"}</p>
        </div>
      ) : null}
      <div className="history-list" aria-label="客户历史邮件">
        {(context?.history || []).map((item) => {
          const displayName = safeText(item.customer_name || item.sender_name || item.sender_email, "未知客户");
          const isCurrent = Number(item.id) === Number(currentInquiryId);
          return (
            <button
              type="button"
              key={item.id}
              className={`history-entry ${isCurrent ? "is-current" : ""}`}
              onClick={() => onOpenHistory(item.id)}
              aria-current={isCurrent ? "true" : undefined}
            >
              <span className="history-entry__head">
                <span className="history-entry__identity">
                  <span className="history-entry__avatar"><UserRound size={15} /></span>
                  <span>
                    <strong className="truncate">{displayName}</strong>
                    <small className="truncate">{safeText(item.customer_email || item.sender_email, "未识别客户邮箱")}</small>
                  </span>
                </span>
                <span className="history-entry__meta">
                  <time>{formatDateTime(item.received_at)}</time>
                  <small>{item.status_label}</small>
                </span>
              </span>
              <span className="history-entry__subject"><Mail size={14} /><strong>{safeText(item.subject || item.product, "无主题")}</strong></span>
              <span className="history-entry__message">{safeText(item.customer_message, "该封邮件暂无可显示的客户正文")}</span>
              <span className="history-entry__action">{isCurrent ? "当前邮件" : "查看完整客户邮件"}<ChevronRight size={14} /></span>
            </button>
          );
        })}
        {!context?.history?.length ? <small>暂无历史询盘。</small> : null}
      </div>
      <details className="follow-up-editor">
        <summary><CalendarClock size={15} />安排后续跟进</summary>
        <div className="follow-up-grid">
          <SelectInput value={followUp.follow_up_status} onChange={(event) => setFollowUp({ ...followUp, follow_up_status: event.target.value })}>
            {Object.entries(FOLLOW_UP_STATUS).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </SelectInput>
          <TextInput type="datetime-local" value={followUp.next_follow_up_at} onChange={(event) => setFollowUp({ ...followUp, next_follow_up_at: event.target.value })} />
          <Button size="sm" loading={busy} onClick={() => onSaveFollowUp(followUp)}>保存</Button>
        </div>
        <div className="note-compose">
          <TextArea value={note} onChange={(event) => setNote(event.target.value)} placeholder="添加内部备注，客户不可见" />
          <Button size="sm" icon={MessageSquarePlus} disabled={!note.trim()} loading={busy} onClick={async () => { await onAddNote(note); setNote(""); }}>添加备注</Button>
        </div>
        <div className="note-list">
          {(context?.notes || []).map((item) => <div key={item.id}><p>{item.content}</p><small>{item.author_name} · {formatDateTime(item.created_at)}</small></div>)}
        </div>
      </details>
    </section>
  );
}
